import { SELECTEDTAB_INDEX } from 'state/selectedTab/constants';

export function getSelectedForm(state, index) {
  const tabIndex = index !== undefined ? index : SELECTEDTAB_INDEX;
  return state.tabs[tabIndex].selectedForm;
}
